import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Product Collection
      {record ? `: ${record.collection_name}` : ''}
    </span>
  );
};
